import ListRegistrasiBarangJadi from './ListRegistrasiBarangJadi';

export default ListRegistrasiBarangJadi;
